
  (() => {
    const STORAGE_KEY = 'unison_member_offer';

    function setMemberOfferState() {
      const params = new URLSearchParams(window.location.search);

      if (params.get('offer') === '1') {
        localStorage.setItem(STORAGE_KEY, '1');
      }

      const offerEnabled =
        params.get('offer') === '1' ||
        localStorage.getItem(STORAGE_KEY) === '1';

      const currentTimestamp = Math.floor(Date.now() / 1000);

      document
        .querySelectorAll('.unison-price-switch')
        .forEach((priceSwitch) => {
          const offerValid =
            priceSwitch.dataset.specialOfferValid === 'true';

          const offerStart =
            Number(priceSwitch.dataset.specialOfferStart || 0);

          const offerEnd =
            Number(priceSwitch.dataset.specialOfferEnd || 9999999999);

          const regularPrice = priceSwitch.querySelector(
            '.unison-price-switch__regular'
          );

          const memberPrice = priceSwitch.querySelector(
            '.js-unison-member-card-price'
          );

          const shouldShowMemberPrice =
            offerEnabled &&
            offerValid &&
            currentTimestamp >= offerStart &&
            currentTimestamp <= offerEnd &&
            memberPrice;

          if (shouldShowMemberPrice) {
            if (regularPrice) {
              regularPrice.hidden = true;
            }

            memberPrice.hidden = false;
          } else {
            if (regularPrice) {
              regularPrice.hidden = false;
            }

            if (memberPrice) {
              memberPrice.hidden = true;
            }
          }
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        setMemberOfferState
      );
    } else {
      setMemberOfferState();
    }

    document.addEventListener(
      'shopify:section:load',
      setMemberOfferState
    );
  })();
